import { Component, EventEmitter, Input, Output } from '@angular/core';

import { VendorModel } from '../vendors/models/vendor';

@Component({
  template: require('./vendor.actions.component.html')
})
export class VendorActionsComponent {
  @Input() record: VendorModel;

  @Output() onEditClick    : EventEmitter<VendorModel> = new EventEmitter();
  @Output() onPaymentClick : EventEmitter<VendorModel> = new EventEmitter();
  @Output() onSMSClick     : EventEmitter<VendorModel> = new EventEmitter();
  @Output() onEmailClick   : EventEmitter<VendorModel> = new EventEmitter();
  @Output() onActivateClick: EventEmitter<VendorModel> = new EventEmitter();
}
